import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export interface ResetPasswordPayload {
    token: string;
    password: string;
}

export interface ResetPasswordResponse {
    msg: string;
}

/**
 * Complete a password reset using the one-time token from the emailed link.
 *
 * Possible responses:
 *   - 200: password reset, the user can now log in.
 *   - 400: the token is invalid, expired (>1h) or already used.
 *   - 403: the password does not meet the length requirement (8–30 chars).
 *   - 429: rate limited (10 requests/hour per IP).
 *
 * The token is sensitive — never log it.
 */
export function post(
    payload: ResetPasswordPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ResetPasswordResponse>> {
    return client.post<ResetPasswordResponse>(`/reset-password`, payload, customConfig);
}
